<div class="h-100 w-100 container-fluid">
  <app-add-building
    class="h-100"
    *ngIf="
      this.buildingManagementService.buildingsView === false &&
      this.sharedData?.selectedSite?.siteId !== ''
    "
    (buildingCreated)="buildingAdded($event)"
  ></app-add-building>
  <app-select-site
    class="h-100 w-100"
    *ngIf="this.sharedData?.selectedSite?.siteId === ''"
  ></app-select-site>
  <div
    class="row h-100 my-lg-5 mx-lg-5 my-xl-5 mx-xl-5 my-xl-5 mx-xl-5 my-md-3 mx-md-3 my-sm-2 mx-sm-2 my-xs-1 mx-xs-1"
    *ngIf="
      this.sharedData?.selectedSite?.siteId !== '' &&
      this.buildingManagementService.buildingsView === true
    "
  >
    <app-building-list
      [buildingsList]="buildingsList"
      class="col-12 col-xl-4 col-mt-5 pr-lg-3 pr-xl-3 mb-md-3"
    ></app-building-list>
    <app-building-details
      class="col-12 col-xl-4 col-mt-5 pr-lg-3 pr-xl-3 mb-md-3"
    ></app-building-details>
    <app-building-unit-details
      [selectedSite]="sharedData?.selectedSite"
      [selectedBuilding]="sharedData?.selectedBuilding"
      [selectedFloor]="sharedData?.selectedFloor"
      [selectedUnit]="sharedData?.selectedUnit"
      class="col-12 col-xl-4 col-mt-5 pr-lg-3 pr-xl-3 mb-md-3"
    ></app-building-unit-details>
  </div>
</div>
